export default __webpack_public_path__ + "static/splash-9c85e20008388d0aa0c78054804acc7d.webp";